import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import axe from '@axe-core/react';
// console.log("process.env", process.env);

// if (process.env.NODE_ENV !== 'production') {
//   axe(React, ReactDOM, 1000);
// }

const wrapper = document.getElementById('app');
wrapper ? ReactDOM.render(<App />, wrapper) : false;
